//server events
export const EMAIL_CAPTURE = 'email_capture';
export const LEAD_FORM_SUBMIT = 'lead_form_submit';
export const DRUPAL_AB_TEST = 'drupal_ab_test_event';
export const REDIRECT_TO_CAPTCHA = 'redirectToCaptcha';
export const HMAC_INVALID_WEBFORM_SUBMIT = 'hmacInvalidWebformSubmit';
export const CAPTCHA_SUBMIT_SUCCESS = 'captchaSubmitSuccess';
export const RECAPTCHA_BOT_SCORE = 'recaptchaBotScore';
export const RECAPTCHA_ASSESSMENT_ID = 'recaptchaAssessmentId';
export const INTERCOM_MESSENGER_OPENED = 'intercomMessengerOpened';
export const INTERCOM_MESSENGER_CLOSED = 'intercomMessengerClosed';
export const INTERCOM_MESSAGE_UNREAD_COUNT_CHANGED = 'intercomMessageUnreadCountChanged';